<template>
  <wo-region v-if="showList">
    <wo-layout>
      <wo-link v-if="allowCompanySwitch" mod-icon mod-icon-after icon="chevron-down" @click.native.prevent="changeCompany">{{ company.name }}</wo-link>
      <wo-title tag-name="h3" v-t="'salespointList.title'"></wo-title>
      <wo-grid>
        <wo-column width-md="6">
          <po-input-field v-model="searchText" v-focus="true" name="searchText" label-key="general.searchText" :debounce="true" placeholder-key="general.searchTextPlaceholder" />
        </wo-column>
      </wo-grid>
    </wo-layout>
    <wo-layout>
      <sales-point-list :filter="filter" :company="company">
        <po-route-link :value="createRoute" slot="actions"></po-route-link>
      </sales-point-list>
    </wo-layout>
  </wo-region>
  <router-view v-else />
</template>

<script>

import { mapState } from 'vuex'
import { showModal } from '@/modal'

import { SALES_POINT_LIST, SALES_POINT_CREATE } from '@/routes/sales-point'

import { Permissions } from '@/model/identity'

import SalesPointList from '@/components/sales-point/SalesPointList'
import CompanySelectModal from '@/components/admin/CompanySelectModal'

export default {
  components: { SalesPointList },
  data () {
    return {
      searchText: undefined
    }
  },
  computed: mapState({
    user: state => state.identity.currentUser,
    company: state => state.company.company,
    allowCompanySwitch () {
      return this.company && this.user.hasPermission(Permissions.CRUD_SALES_POINT)
    },
    showList () {
      return this.$route.name === SALES_POINT_LIST
    },
    filter () {
      return this.company && {
        search_text: this.searchText,
        size: 50
      }
    },
    createRoute () {
      return {
        name: SALES_POINT_CREATE
      }
    }
  }),
  methods: {
    changeCompany () {
      showModal(CompanySelectModal, { customersOnly: true })
        .then(company => this.$router.push({ name: SALES_POINT_LIST, params: { companyId: company.id } }))
        .catch(e => {})
    }
  }
}
</script>
